// Lines/Drains subsection questionnaire constants
export enum LinesDrainsQuestionnaireItem {
  MEDICAL_BACKGROUND_LINES_DRAINS = 'medical-background/lines-drains',
  MEDICAL_BACKGROUND_LINES_DRAINS_SYSTEM_SUMMARY = 'medical-background/lines-drains/system-summary'
}
